import { render, staticRenderFns } from "./LayoutDrawerItem.vue?vue&type=template&id=3bf4bd8e&"
import script from "./LayoutDrawerItem.vue?vue&type=script&lang=js&"
export * from "./LayoutDrawerItem.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDrawerItem.vue?vue&type=style&index=0&id=3bf4bd8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QItemSection,QAvatar});
